// BadgeDisplay — renders one or many badges with tooltip on hover.
import React, { useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const TIER_RING = {
  bronze: "0 0 0 1.5px rgba(136, 135, 128, 0.55)",
  silver: "0 0 0 1.5px rgba(133, 183, 235, 0.65)",
  gold: "0 0 0 1.5px rgba(245, 166, 35, 0.65)",
  special: "0 0 0 1.5px rgba(155, 89, 255, 0.7)",
};

const SIZE_MAP = {
  sm: { px: 26, font: 14 },
  md: { px: 36, font: 18 },
  lg: { px: 48, font: 24 },
};

const BadgePill = ({ badge, size = "md" }) => {
  const { lang } = useLanguage();
  const [hover, setHover] = useState(false);
  const cfg = SIZE_MAP[size] || SIZE_MAP.md;
  const nombre = badge?.nombre?.[lang] || badge?.nombre?.es || badge?.id;
  const desc = badge?.descripcion?.[lang] || badge?.descripcion?.es || "";

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid={`badge-${badge.id}`}
      style={{ position: "relative", display: "inline-block" }}
    >
      <div
        style={{
          width: cfg.px,
          height: cfg.px,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.04)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: cfg.font,
          lineHeight: 1,
          boxShadow: TIER_RING[badge.tier] || TIER_RING.bronze,
          cursor: "default",
        }}
        title={nombre}
      >
        {badge.emoji}
      </div>
      {hover && desc && (
        <div
          style={{
            position: "absolute",
            top: cfg.px + 6,
            left: "50%",
            transform: "translateX(-50%)",
            background: "#0a0b16",
            border: `1px solid ${badge.color || "rgba(255,255,255,0.18)"}`,
            color: "#f0f4ff",
            padding: "8px 12px",
            borderRadius: 8,
            fontSize: 11,
            whiteSpace: "nowrap",
            zIndex: 50,
            boxShadow: "0 4px 16px rgba(0,0,0,0.45)",
          }}
        >
          <div style={{ fontWeight: 700, color: badge.color || "#f5a623" }}>{nombre}</div>
          <div style={{ marginTop: 3, opacity: 0.75, fontSize: 10 }}>{desc}</div>
        </div>
      )}
    </div>
  );
};

export const BadgeDisplay = ({ badges = [], max = 5, size = "md" }) => {
  if (!badges?.length) return null;
  const shown = badges.slice(0, max);
  const extra = badges.length - shown.length;
  return (
    <div className="inline-flex items-center gap-1.5" data-testid="badge-display">
      {shown.map((b) => (
        <BadgePill key={b.id} badge={b} size={size} />
      ))}
      {extra > 0 && (
        <span
          style={{
            fontSize: 11,
            color: "rgba(255,255,255,0.5)",
            fontWeight: 600,
            marginLeft: 4,
          }}
        >
          +{extra}
        </span>
      )}
    </div>
  );
};

export default BadgeDisplay;
